<!-- Month/Year Picker – shared toolbar-left widget. -->

<!-- ── Compact mode: Year | May ∨  2025 ∨ ───────────────────────────────── -->
@if (mode() === 'compact') {
<div class="lm-compact-pill">
  <span class="lm-compact-label">{{ 'leave_management.month_year_picker.year' | transloco }}</span>
  <span class="lm-compact-divider"></span>
  <select class="lm-compact-select" (change)="onCompactMonthChange($event)">
    @for (m of months; track $index; let i = $index) {
    <option [value]="i" [selected]="i === currentMonth()">{{ m.slice(0,3) }}</option>
    }
  </select>
  <select class="lm-compact-select" (change)="onCompactYearChange($event)">
    @for (y of years; track y) {
    <option [value]="y" [selected]="y === currentYear()">{{ y }}</option>
    }
  </select>
</div>
}

<!-- ── Default mode: prev/next + popup ──────────────────────────────────── -->
@if (mode() === 'default') {
<button class="lm-icon-btn" (click)="prevMonth()" [title]="'leave_management.month_year_picker.title.previous_month' | transloco">
  <mat-icon>{{ 'leave_management.month_year_picker.chevron_left' | transloco }}</mat-icon>
</button>

<div class="lm-date-display" (click)="togglePicker()" ersClickable>
  <mat-icon class="lm-date-icon">{{ 'leave_management.month_year_picker.event' | transloco }}</mat-icon>
  <span class="lm-date-text">{{ displayDate }}</span>
</div>

<button class="lm-icon-btn" (click)="nextMonth()" [title]="'leave_management.month_year_picker.title.next_month' | transloco">
  <mat-icon>{{ 'leave_management.month_year_picker.chevron_right' | transloco }}</mat-icon>
</button>

<!-- Inline dropdown picker -->
@if (showPicker) {
<div class="lm-picker-dropdown">

  <div class="lm-picker-section">
    <span class="lm-picker-label">{{ 'leave_management.month_year_picker.month' | transloco }}</span>
    <div class="lm-picker-grid months">
      @for (m of months; track $index; let i = $index) {
      <button
        class="lm-picker-cell"
        [class.active]="i === currentMonth()"
        (click)="selectMonth(i)">
        {{ m.slice(0, 3) }}
      </button>
      }
    </div>
  </div>

  <div class="lm-picker-section">
    <span class="lm-picker-label">{{ 'leave_management.month_year_picker.year' | transloco }}</span>
    <div class="lm-picker-grid years">
      @for (y of years; track y) {
      <button
        class="lm-picker-cell"
        [class.active]="y === currentYear()"
        (click)="selectYear(y)">
        {{ y }}
      </button>
      }
    </div>
  </div>

</div>
}
}
